import * as React from 'react'
import { cn } from '../../../lib/utils'

/** Outer chat container. Fill the parent via `className` (e.g. `h-full`). */
const Chat = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			data-slot="chat"
			className={cn('flex h-full flex-col gap-3 overflow-hidden', className)}
			{...props}
		/>
	)
)
Chat.displayName = 'Chat'

/** Scrollable message stack — expects ChatMessage / ChatAttachment / ChatEventCard / ChatImage as children. */
const ChatMessages = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			data-slot="chat-messages"
			className={cn('flex flex-1 flex-col gap-2 overflow-y-auto px-1 py-2', className)}
			{...props}
		/>
	)
)
ChatMessages.displayName = 'ChatMessages'

/** Centered date separator ("24 марта"). */
const ChatDateDivider = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, children, ...props }, ref) => (
		<div
			ref={ref}
			data-slot="chat-date-divider"
			className={cn('my-2 flex items-center justify-center', className)}
			{...props}
		>
			<span className="text-xs leading-4 text-(--color-muted-foreground)">{children}</span>
		</div>
	)
)
ChatDateDivider.displayName = 'ChatDateDivider'

export { Chat, ChatMessages, ChatDateDivider }
